import { useQuery } from '@tanstack/react-query'

import { flagInstance } from '@/modules/featureFlags'
import { useAuthContext } from '@/ui/contexts/AuthContext'

export function useFeatureFlagsQuery() {
  const { personaSession } = useAuthContext()

  return useQuery({
    queryKey: ['featureFlags'],
    queryFn: async () => await flagInstance.listFlags(),
    enabled: !!personaSession?.personaId
  })
}
